import { useEffect, useState } from "react";
import { findAllClientsPagedEvent, findAllClientsByNamePagedEvent } from "../../_events/order_list_view/find.event";
import { message } from "antd";
import { buildPagedDataFetched, emptyPagedData } from "../../_utils/paged-data";

export const useClientsPaged = () => {
    
    const [ nameFilter, setNameFilter ] = useState('');
    const [ page, setPage ] = useState(0);
    const [ count, setCount ] = useState(10);
    const [ pagedData, setPagedData ] = useState(emptyPagedData);


    const loadData = (p, c) => {
        if(nameFilter === '' || nameFilter === null){
            findAllClientsPagedEvent(p, c)
            .then(json => {
                setPagedData(buildPagedDataFetched(json.paged));
            })
            .catch(err => {
                message.error(err.message);
            });
        } else {
            loadDataFilter(nameFilter, p, c);
        }
        
    }

    const loadDataFilter = (name, p, c) => {
        findAllClientsByNamePagedEvent(name, p, c)
        .then(json => {
            setPagedData(buildPagedDataFetched(json.paged));
        })
        .catch(err => {
            message.error(err.message);
        });
    }

    useEffect(() => {
        loadData(page, count);
    }, []);
    
    return {
        nameFilter, page, count, pagedData, setNameFilter, setPage, setPagedData, loadData, loadDataFilter
    };
}